import React from 'react';
import VisitorCounter from './VisitorCounter';

function Footer() {
    return <>
        <footer className="pt-2 pb-2" style={{ fontSize: '0.65rem', minHeight: '2rem' }}>
            <div className="flex justify-between items-center px-4">
                <div className="flex-1"></div>
                <div className="text-center flex-1">
                    Copyright 2022 - <a target="_blank" href="https://www.yorku.ca/research/">York University Research</a>
                </div>
                <div className="text-right flex-1">
                    Total Unique Visitors: <VisitorCounter />
                </div>
            </div>
        </footer>
    </>
}

export default React.memo(Footer);
